import IconAlert from '@/components/common/IconAlert';
import Flex from '@/components/common/Flex';
import useDomain from '@/hooks/useDomain';
import { useGetTariffInfoQuery } from '../../api/keywordsApi';
import { isTrackerKeywordsTariffZero } from '../../utils/trackerTariff';
import TrackerKeywordsInactiveAlert from '../TrackerKeywordsInactiveAlert';

const KeywordsAccessAlerts = () => {
  const { domain_slug } = useDomain();
  const { data: trackerInfo, isFetching } = useGetTariffInfoQuery(domain_slug);

  if (isFetching || !trackerInfo?.data?.tariff) {
    return null;
  }

  if (isTrackerKeywordsTariffZero(trackerInfo)) {
    return <TrackerKeywordsInactiveAlert />;
  }

  const isKeywordsOver = () => {
    if (isTrackerKeywordsTariffZero(trackerInfo)) {
      return false;
    }

    return (
      trackerInfo?.data?.used?.num_of_keywords >
      trackerInfo?.data?.tariff?.num_of_keywords
    );
  };

  const isDomainsOver = () =>
    trackerInfo?.data?.used?.num_of_domains >
    trackerInfo?.data?.tariff?.num_of_domains;

  const isCompetitorsOver = () =>
    trackerInfo?.data?.used?.num_of_competitors >
    trackerInfo?.data?.tariff?.num_of_competitors;

  return (
    (isKeywordsOver() || isDomainsOver() || isCompetitorsOver()) && (
      <>
        <IconAlert variant="warning">
          <Flex direction="column" className="gap-1">
            {isKeywordsOver() && (
              <div>
                درحال حاضر
                <strong className="mx-2">
                  {trackerInfo?.data?.used?.num_of_keywords}
                </strong>
                کلمه داری و با توجه به طرح انتخابی باید تعدادش رو به
                <strong className="mx-2">
                  {trackerInfo?.data?.tariff?.num_of_keywords}
                </strong>
                برسونی (
                <strong className="mx-2">
                  {trackerInfo?.data?.used?.num_of_keywords -
                    trackerInfo?.data?.tariff?.num_of_keywords}
                </strong>
                کلمه باید حذف بشه)
              </div>
            )}
            {isDomainsOver() && (
              <div>
                درحال حاضر
                <strong className="mx-2">
                  {trackerInfo?.data?.used?.num_of_domains}
                </strong>
                دامنه داری و با توجه به طرح انتخابی باید تعدادش رو به
                <strong className="mx-2">
                  {trackerInfo?.data?.tariff?.num_of_domains}
                </strong>
                برسونی (
                <strong className="mx-2">
                  {trackerInfo?.data?.used?.num_of_domains -
                    trackerInfo?.data?.tariff?.num_of_domains}
                </strong>{' '}
                دامنه باید حذف بشه)
              </div>
            )}
            {isCompetitorsOver() && (
              <div>
                درحال حاضر
                <strong className="mx-2">
                  {trackerInfo?.data?.used?.num_of_competitors}
                </strong>
                رقیب داری و با توجه به طرح انتخابی باید تعدادش رو به
                <strong className="mx-2">
                  {trackerInfo?.data?.tariff?.num_of_competitors}
                </strong>
                برسونی (
                <strong className="mx-2">
                  {trackerInfo?.data?.used?.num_of_competitors -
                    trackerInfo?.data?.tariff?.num_of_competitors}
                </strong>
                رقیب باید حذف بشه)
              </div>
            )}
          </Flex>
        </IconAlert>
        <IconAlert variant="danger">
          امکان بروزرسانی کلمات به علت عدم مطابقت با طرح فعلی وجود نداره
        </IconAlert>
      </>
    )
  );
};

export default KeywordsAccessAlerts;
